import $ from 'jquery';
import Analytics from 'modules/analytics/analytics';
import Cookie from 'modules/cookie/cookie';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaOrderThankyou'
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.analytics = new Analytics();
		this.data = {};
		this.$window = $(window);
		this.cookie = new Cookie();
		return this;
	}

	render() {
		if (this.$el.length) {
			if (yotaPortlets.orderThankyou) {
				this.data = yotaPortlets.orderThankyou;
			} else {
				const e1 = this.cookie.get('checkoutEvent8_1');
				if (typeof e1 != 'undefined') {
					this.data = {};
					this.data.analytics = {};
					this.data.analytics['event'] = decodeURIComponent(e1);
					this.data.analytics['NAME'] = decodeURIComponent(this.cookie.get('checkoutEvent8_2'));
					this.data.analytics['ID_PRODUCT'] = decodeURIComponent(this.cookie.get('checkoutEvent8_3'));
					this.data.analytics['CATEGORY'] = decodeURIComponent(this.cookie.get('checkoutEvent8_4'));
					this.data.analytics['PRICE'] = decodeURIComponent(this.cookie.get('checkoutEvent8_5'));
					this.data.analytics['QUANTITY'] = decodeURIComponent(this.cookie.get('checkoutEvent8_6'));
					this.data.analytics['Город доставки'] = decodeURIComponent(this.cookie.get('checkoutEvent8_7'));
					this.data.analytics['Способ доставки'] = decodeURIComponent(this.cookie.get('checkoutEvent8_8'));
					this.data.analytics['ID_TRANSACTION'] = decodeURIComponent(this.cookie.get('checkoutEvent8_9'));
					this.data.analytics['REVENUE'] = decodeURIComponent(this.cookie.get('checkoutEvent8_10'));
				}
			}

			this.analytics.setData(this.data.analytics);
			this.analytics.push({});

			this.cookie.remove('checkoutEvent8_1');
			this.cookie.remove('checkoutEvent8_2');
			this.cookie.remove('checkoutEvent8_3');
			this.cookie.remove('checkoutEvent8_4');
			this.cookie.remove('checkoutEvent8_5');
			this.cookie.remove('checkoutEvent8_6');
			this.cookie.remove('checkoutEvent8_7');
			this.cookie.remove('checkoutEvent8_8');
			this.cookie.remove('checkoutEvent8_9');
			this.cookie.remove('checkoutEvent8_10');
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order-thankyou/order-thankyou.js